define(function (require) {
	const tpl = require('../templates/t_lov_unified_mfa_setup.hbs');
	const ViewManager = require('civicsUtils/view_manager');
	const user_data_utils = require('civicsUtils/user_data_utils');
	const twoFactorUtility = require('civicsViews/core/two_factor_authentication/2fa_utility');
	const responseUtils = require('civicsViews/core/two_factor_authentication/2fa_response_utils');
	const mfa_subscription_model = require('civicsModels/mfa_subscription_model');
	const ccn = require('civicsViews/core/core_constants');
	const Utils = require('civicsUtils/general_utilities');
	const MfaSuccessModal = require('./v_lov_mfa_success');
	const StepAnimationUtils = require('../utils/step_animation_utils');

	return Marionette.LayoutView.extend({
		className: 'v-lov-unified-mfa-setup-modal',
		template: tpl,
		regions: {
			confirmationRegion: {
				selector: '.confirmation-modal-container'
			}
		},
		ui: {
			closeButton: '.bbm-btn-close',
			continueButton: '.continue-setup-modal',
			methodOption: '.method-option',
			submitButton: '.submit-code',
			authenticationCodeField: '#authentication-code',
			mobileNumberField: '#mobile-number',
			resendCodeLink: '.resend-code-link',
			backButton: '.back-button',
			step1: '.step-1',
			step2: '.step-2',
			step3: '.step-3',
			modalTitle: '#modal-title-unified-mfa',
			unifiedFooterBtn: '.unified-footer .btn',
			confirmationModalContainer: '.confirmation-modal-container'
		},
		events: {
			'click @ui.closeButton': 'closeModal',
			'click @ui.continueButton': 'continueSetup',
			'click @ui.methodOption': 'selectMethod',
			'click @ui.submitButton': 'submitClicked',
			'click @ui.resendCodeLink': 'resendCodeClicked',
			'click @ui.backButton': 'goBackToStep1',
			'keyup @ui.authenticationCodeField': 'onAuthCodeKeyup',
			'keyup @ui.mobileNumberField': 'onMobileNumberKeyup',

		},
		initialize: function (options) {
			this.options = options;
			this.config = options.config?.config || options.config || {};
			this.globalConfig = ViewManager.globalConfig().toJSON();
			this.modalRegion = options.modalRegion;
			this.activeProcess = options.activeProcess;
			this.wizardProject = options.wizardProject;
			this.existingMethods = options.existingMethods || [];
			this.currentStep = 1;
			this.selectedMethod = null;
			this.twoFactorUtil = twoFactorUtility({ modalRegion: this.modalRegion });
		},
		onShow: function () {
			this.$el.rhythmThemeInit();
			this.$el.rhythmThemeInitCivics();
			
			// Ensure proper initial state
			this.ui.backButton.hide();
			
			// Disable already added methods
			this.disableExistingMethods();
		},
		onAuthCodeKeyup: function(e) {
			if (e.key === 'Enter' || e.keyCode === 13) {
				this.submitClicked();
			}
		},
		onMobileNumberKeyup: function(e) {
			// Clear error when user starts typing
			ViewManager.resetErrorMessages(this);
			
			if (e.key === 'Enter' || e.keyCode === 13) {
				this.continueSetup();
			}
		},
		goBackToStep1: function(e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			// Clear any validation errors
			ViewManager.resetErrorMessages(this);
			// Clear the authentication code input
			this.ui.authenticationCodeField.val('');
			this.slideToStep(1);
		},
		updateStepControls: function(stepNumber) {
			if (stepNumber === 1) {
				this.ui.unifiedFooterBtn.removeClass('submit-code').addClass('continue-setup-modal');
				this.ui.unifiedFooterBtn.text(i18n.t('CIVICS.LOGIN.ENFORCED_MFA.CONTINUE_BTN'));
				this.ui.backButton.hide();
			} else if (stepNumber === 2) {
				this.ui.unifiedFooterBtn.removeClass('submit-code').addClass('continue-setup-modal');
				this.ui.unifiedFooterBtn.text(i18n.t('CIVICS.LOGIN.ENFORCED_MFA.CONTINUE_BTN'));
				this.ui.backButton.show();
			} else if (stepNumber === 3) {
				this.ui.unifiedFooterBtn.removeClass('continue-setup-modal').addClass('submit-code');
				this.ui.unifiedFooterBtn.text(i18n.t('CIVICS.COMMON.CONTINUE'));
				this.ui.backButton.show();
			}
		},
		slideToStep: function(stepNumber) {
			const $currentStep = this.ui['step' + this.currentStep];
			const $nextStep = this.ui['step' + stepNumber];
			const direction = stepNumber > this.currentStep ? 'left' : 'right';
			
			// Update title using animation utility
			const titles = {
				1: this.templateHelpers().title2,
				2: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.ADD_MOBILE_NUMBER_HEADER'),
				3: this.templateHelpers().title3
			};
			StepAnimationUtils.updateModalTitle(this.ui.modalTitle, stepNumber, titles);
			
			// Animate step transition using utility
			StepAnimationUtils.animateStepTransition($currentStep, $nextStep, direction, () => {
				// Focus input after animation completes and populate mobile number
				if (stepNumber === 2) {
					setTimeout(() => {
						this.ui.mobileNumberField.focus();
					}, 50);
				} else if (stepNumber === 3) {
					setTimeout(() => {
						this.ui.authenticationCodeField.focus();
					}, 50);
				}
			});
			
			this.updateStepControls(stepNumber);
			this.currentStep = stepNumber;
		},

		selectMethod: function (e) {
			const radioButton = this.$(e.currentTarget).find('input[type="radio"]');
			if (radioButton.length && !radioButton.prop('disabled')) {
				radioButton.prop('checked', true);
			} else if (radioButton.hasClass('disabled')) {
				// this.showDisabledMethodMessage(e);
			}
		},
		continueSetup: function (e) {
			if (this.currentStep === 1) {
				// Step 1: Method selection
				const selectedMethod = this.$('input[name="mfa-method"]:checked').val();
				if (!selectedMethod) {
					return;
				}
				
				this.selectedMethod = selectedMethod;
				
				if (selectedMethod === 'sms') {
					// SMS - try direct setup first
					this.setupMfaMethod('SMS');
				} else {
					// Email - proceed directly to setup
					this.setupMfaMethod('Email');
				}
			} else if (this.currentStep === 2) {
				// Step 2: Mobile number input (SMS only)
				const mobileNumber = this.ui.mobileNumberField.val();
				const trimmedNumber = mobileNumber ? mobileNumber.trim() : '';
				
				if (!trimmedNumber || trimmedNumber.length === 0) {
					const error = { validationError: { mobileNumber: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.MOBILE_NUMBER_VALIDATION') } };
					ViewManager.errorToWindow(error, this);
					return;
				}
				
				// Clear any previous errors
				ViewManager.resetErrorMessages(this);
				
				this.setupMfaMethod('SMS', trimmedNumber);
			}
		},
		setupMfaMethod: function(method, mobileNumber) {
			const methodData = {
				notificationMethod: method,
				providerType: method
			};
			
			// Check if user has existing MFA subscriptions
			const existingMfaSubscriptions = App.user?.mfaSubscriptions || [];
			if (existingMfaSubscriptions.length === 0) {
				// First MFA subscription - set as primary with priority 1
				methodData.isSetup = true;
				methodData.priority = 1;
			}
			
			if (mobileNumber) {
				// Clean and format the mobile number
				const cleanNumber = mobileNumber.replace(/\D/g, '');
				methodData.mobileNumber = cleanNumber;
			}
			
			const mfaSubModel = new mfa_subscription_model(methodData);
			ViewManager.loading(true);
			
			mfaSubModel.save().fail((response) => {
				if (response.status == 403 &&
					response.responseJSON && 
					response.responseJSON.data &&
					response.responseJSON.data.mfaStatus.toLowerCase() == ccn.NOTIFIED) {
					
					this.setupAuthenticationStep(response, mfaSubModel);
				} else if (method === 'SMS' && !mobileNumber) {
					// SMS failed because no mobile number - go to step 2
					this.slideToStep(2);
				} else {
					ViewManager.errorToWindow(response);
				}
			}).always(() => {
				ViewManager.loading(false);
			});
		},
		setupAuthenticationStep: function(response, originalModel) {
			let parsedResponse = responseUtils.parseResponse(response);
			this.mfaToken = parsedResponse.mfaToken;
			this.factor = parsedResponse.factor;
			this.originalModel = originalModel;
			this.codeType = ccn.VERIFICATION;
			this.method = ccn.SAVE;
			
			// Update step 3 content with contact details
			const bodyText = i18n.t('CIVICS.LOGIN.ENFORCED_MFA.VERIFY_ITS_YOU_EMAIL_2FA_HEADER_INSTRUCTIONAL_MSG', {details: this.factor.details});
			this.ui.step3.find('.authentication-text').text(bodyText);
			
			this.slideToStep(3);
		},
		submitClicked: function(e) {
			if(e) {
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.submitButton.prop('disabled', true);
			let code = this.getAuthenticationCode();
			if(code) {
				this.saveAuthenticationCode(code);
			} else {
				this.ui.submitButton.prop('disabled', false);
			}
		},
		getAuthenticationCode: function() {
			return responseUtils.getAuthenticationCode(this);
		},
		saveAuthenticationCode: function(data) {
			ViewManager.loading(true);
			let options = {
				headers: {
					'X-IPS-PortalAuth-Token': this.mfaToken,
					'X-IPS-PortalAuth-Claim': data.authenticationCode
				}
			};
			
			let httpPromise = this.originalModel.save(null, options);
			$.when(httpPromise).done((response) => {
				// Check if there's an invite record or process manager before clearing storage
				const hasActiveProcess = App.sessionStorage.get('PROCESSMANAGER', 'ACTIVE_PROCESS');
				const hasWizardProject = App.sessionStorage.get('CIVICS', 'WIZARD');
				
				if (!hasActiveProcess || !hasWizardProject) { // Do not clear sessionStorage and localStorage when there's an active Invite or a Wizard Project being saved.
					ViewManager.clearUserSpecificSessionStorage(["USER_SESSION"]);
					ViewManager.clearUserSpecificLocalStorage();
				}
				ViewManager.loading(false);
				this.showSuccessModal();
			}).fail((response) => {
				this.handleErrorResponse(response);
			});
		},
		handleErrorResponse: function(response) {
			responseUtils.handleErrorResponse(response, this, this.codeType);
		},
		cancelLogin: function(reason) {
			this.twoFactorUtil.showAuthenticationFailureModal({reason: reason}, null, this.codeType);
		},
		resendCodeClicked: function(e) {
			if(e) {
				e.stopPropagation();
				e.preventDefault();
			}
			ViewManager.loading(true);
			let httpPromise = this.originalModel.save(null);
			$.when(httpPromise).fail((response) => {
				if (response.status == 403) {
					let parsed = responseUtils.parseResponse(response);
					this.mfaToken = parsed.mfaToken;
					Utils.civicsToastPop(i18n.t('CIVICS.LOGIN.FACTOR_AUTH.CODE_RESENT', {details: this.factor.details}), "success");
				} else {
					this.handleErrorResponse(response);
				}
			}).always(() => {
				ViewManager.loading(false);
			});
		},
		showSuccessModal: function() {
			const successModal = new MfaSuccessModal({
				config: this.config,
				modalRegion: this.modalRegion,
				activeProcess: this.activeProcess,
				wizardProject: this.wizardProject
			});

			this.twoFactorUtil.showModalView(successModal);
		},
		disableExistingMethods: function() {
			if (this.existingMethods.includes('email')) {
				this.ui.methodOption.filter(':has(#email-method)').attr('data-direct-tooltip', i18n.t('CIVICS.LOGIN_FALLBACK.METHOD_ALREADY_ADDED'));
				this.$('#email-method').addClass('disabled').prop('disabled', true);
			}
			if (this.existingMethods.includes('sms')) {
				this.ui.methodOption.filter(':has(#sms-method)').attr('data-direct-tooltip', i18n.t('CIVICS.LOGIN_FALLBACK.METHOD_ALREADY_ADDED'));
				this.$('#sms-method').addClass('disabled').prop('disabled', true);
			}
			this.$el.rhythmCivicsTooltipInit(); // Initialization should be placed here since the adding of data-direct-tooltip is conditionally added.
		},
		closeModal: function(e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			if (this.globalConfig.mfaEnforced && App.localStorage.get('CIVICS', 'REQUIRES_MFA_ENROLLMENT')) {
				this.ui.confirmationModalContainer.removeClass('hidden');
				
				let confirmCloseMFASetup = this.twoFactorUtil.showMFASetupSkipConfirmation(this.onConfirmClose.bind(this));
				this.showChildView('confirmationRegion', confirmCloseMFASetup);
				return false;
			} else {
				this.onConfirmClose();
			}
		},
		onConfirmClose: function() {
			ViewManager.loading(true);
			if (this.globalConfig.mfaEnforced && App.localStorage.get('CIVICS', 'REQUIRES_MFA_ENROLLMENT')) {
				App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
		        window.location.href = '/c/portal/logout';
			} else {
				this.modalRegion.hideModal();
				ViewManager.loading(false);
			}
		},
		templateHelpers: function () {
			let contactDetails = this.factor?.details || '';
			let methodType = twoFactorUtility().getAuthenticationStrings();
			const emailDisabled = this.existingMethods?.includes('email');
			const smsDisabled = this.existingMethods?.includes('sms');
			
			// Check the first enabled method (email first, then SMS)
			const emailChecked = !emailDisabled;
			const smsChecked = emailDisabled && !smsDisabled;
			
			return {
				title1: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.LETS_SECURE_YOUR_ACCOUNT_HEADER'),
				bodyText1: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.LETS_SECURE_YOUR_ACCOUNT_INSTRUCTIONAL_MSG'),
				title2: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.HELP_PROTECT_ACC_HEADER'),
				bodyText2: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.HELP_PROTECT_ACC_INSTRUCTIONAL_MSG', {methodTypeBody: methodType.methodTypeBody}),
				title3: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.VERIFY_ITS_YOU_HEADER'),
				bodyText3: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.VERIFY_ITS_YOU_EMAIL_2FA_HEADER_INSTRUCTIONAL_MSG', {details: contactDetails}),
				authenticationPlaceholder: '',
				smsHelperMsg: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SMS_METHOD_HELPER_MSG'),
				emailChecked: emailChecked,
				smsChecked: smsChecked
			};
		}
	});
});